import { Project, ProjectStack, Skill } from '@shared/types';
import { ProjectActivityArgs } from './project';
import {
  AssignMentorResponse,
  AssignMenteeResponse,
  UnassignMenteeResponse,
  UnassignMentorResponse,
  EmployeeProjectInfoResponse,
  TrainingPresentationResponse,
  EmployeeEducationResponse,
  ProjectInfoResponse,
  ProjectMembersResponse,
} from './api';
import { EmployeeEducation, EmployeeCertification } from './employee';
import { CHAT_PAGE_CONTEXT } from '@/constants/chatbot';

export type CancelArgs = { cancel: string };
export type ErrorArgs = { error: string };
export type SuccessArgs = { success: string };
export type RespondArgs = { respond: ((result: string) => void) | undefined };
export type ProjectEvent = {
  name?: string;
  description?: string;
  dateTime?: string;
  scheduledDateTime?: string;
};

export type ArgsType = {
  messageId?: string;
  stopLastToolCall?: boolean;
  name?: string;
  code?: string;
  logo?: string;
  role?: string;
  mode?: string;
  logoBase64?: string;
  desc?: string;
  description?: string;
  stacks?: ProjectStack[];
  addStacks?: ProjectStack[];
  removeStacks?: ProjectStack[];
  cancel?: string;
  error?: string;
  result?: string;
  success?: string;
  rawMessage?: string;
  succeed?: boolean;
  archive?: boolean;
  status?: string;
  respond?: ((result: string) => void) | undefined;
  members?: ProjectMembersResponse;

  // Employee-specific fields
  title?: string; // Job title
  birthday?: string;
  phone?: string;
  address?: string;
  bio?: string;
  gender?: string;
  field?: string;
  value?: string;
  updatedAt?: string;
  project?: string;
  action?: string;
  data?:
    | AssignMentorResponse
    | AssignMenteeResponse
    | UnassignMenteeResponse
    | UnassignMentorResponse
    | EmployeeProjectInfoResponse
    | TrainingPresentationResponse
    | EmployeeEducationResponse
    | ProjectInfoResponse
    | ProjectMembersResponse;

  // Training-specific fields
  training?: string;
  newValueTopic?: string;
  estEndDate?: string;
  startDate?: string;
  identities?: string;
  topicLabel?: string;
  presentation?: string;
  presentationTitle?: string;
  presentationContent?: string;
  presentationStartDate?: string;
  newPresentationTitle?: string;
  participants?: string[];

  // Skills update fields
  group?: string;
  addSkills?: Skill[];
  removeSkills?: Skill[];

  // Education update fields
  addEducations?: EmployeeEducation[];
  updateEducations?: EmployeeEducation[];
  removeEducations?: EmployeeEducation[];

  // Certification update fields
  addCerts?: EmployeeCertification[];
  updateCerts?: EmployeeCertification[];
  removeCerts?: EmployeeCertification[];

  // Activity fields
  activity?: Project['projectInfo'] | ProjectActivityArgs;

  // Validation result fields (returned by agent actions)
  invalid?: string;
  duplicates?: string;
  nonExisting?: string;
  invalidDates?: string;
  invalidUrls?: string;

  waiting?: boolean;
  humanInTheLoop?: boolean;
  event?: string | ProjectEvent;
};

export type RawDataMessage = {
  image: File;
};

export type ActionHandler = 'complete' | 'inProgress' | 'executing';

export enum ToolAvailability {
  ENABLED = 'enabled', // Tool is available and can be called
  DISABLED = 'disabled', // Tool is only for rendering, cannot be called
  REMOTE = 'remote', // Agent can see and call this Frontend action
}

export type SuggestionsType = {
  id: string;
  label: string;
  prompt: string;
};

export type CopilotProperties = {
  showDevConsole: boolean;
  runtimeUrl: string;
  agent: string;
  headers: {
    Authorization: string;
  };
  properties: {
    currentUser?: string | undefined;
    isUser?: boolean | undefined;
    relationship?: string | undefined;
    token: string | null;
    aborted?: boolean;
  };
};

export type ChatPageContextType =
  (typeof CHAT_PAGE_CONTEXT)[keyof typeof CHAT_PAGE_CONTEXT];
